import React from 'react'

import { Box, CardContent, CardHeader } from '@mui/material'
import { useCustomerStatistics } from 'features/customers/hooks/useCustomerStatistics'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

type CustomerMetricsChartProps = {
  dates: { end: string; start: string }
  label: string
  tooltip: string
  type: 'leads' | 'contacts'
}

const CustomerMetricsChart = ({ dates, label, type, tooltip }: CustomerMetricsChartProps) => {
  const { start, end } = dates
  const { data } = useCustomerStatistics(type, start, end)

  const chartData = data.map(x => ({ ...x, label: `${x.month}/${x.year}` }))

  return (
    <Box sx={{ mb: '1rem', '&:last-child': { mb: 0 } }}>
      <CardHeader subheader={label} />

      <CardContent>
        <ResponsiveContainer height={250}>
          <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorBlue" x1="0" x2="0" y1="0" y2="1">
                <stop offset="5%" stopColor="#2196f3" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#2196f3" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#eee" />
            <Tooltip />
            <XAxis dataKey="label" />
            <YAxis />
            <Area
              activeDot={{ strokeWidth: 0, r: 4 }}
              dataKey="count"
              fill="url(#colorBlue)"
              fillOpacity={1}
              name={tooltip}
              stroke="#2196f3"
              type="monotone"
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Box>
  )
}

export default CustomerMetricsChart
